import React from 'react'
import Ui from '../../../presentationals/Admin/BulkActions/DisburseByICICI.component'
import OTPUi from '../../../presentationals/Admin/BulkActions/DisburseByICICI.componentOTPVerification'
import {
    getLoanApprovalLead, BulkPaymentICICI, verifyIciciPayments, verifyIciciPaymentsPenalty, getNbfcList, getDisbursmentOtpSendByData
} from '../AdminActionCreator.component';
import { STRING, ROLE } from '../../../../utils/Constant'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'
import { data } from 'jquery';
import RingTone from './success-48018.mp3'
import { ABHICASH_LIKE, CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT } from '../../../../layouts/MainTenantconfig';
import { APIS } from '../../../../utils/api-factory';
let ids = { "1auHwvWSfNzNETYDEbOGv8g0Vjs8NyhQ": "PENDING", "Nrjuo9ixzrclGEIbMNHPxVGIeXYosXuJ": 'rtyui' }

let dataTosend = []
let ApplicationId = []
let newdataToCheck = []
class Bank extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            followUpStatus: STRING.APPROVED_STATUS,
            forwordPageState: 1,
            searchByDate: '',
            tabType: 'Advance',
            searchByEndDate: '',
            allUserDetail: '',
            loaderState: '',
            popupState: false,
            popupStatus: '',
            paymentData: '',
            loanIdData: '',
            playingState: false,
            nbfcList: [],
            selectednbfcFilter: '',
            selectAll: false,
            penaltyMethodOption: { show: false, penaltyMethod: "" },
            netAmountValue: "",
            OTPpopup: false


        }
    }
    selectAll(e) {
        if (this.state.allUserDetail && e.target.checked) {
            this.setState({ selectAll: true })
            this.state.allUserDetail.map((dataNew, i) => {
                dataTosend.push(dataNew.loanId)
                newdataToCheck.push(i)
                document.getElementById('disburseIcici' + i).checked = true
            })
        } else {
            this.setState({ selectAll: false })
            dataTosend = []
            newdataToCheck.map((newl, i) =>
                document.getElementById('disburseIcici' + newl).checked = false
            )
        }
    }

    closePopup() {
        this.setState({ popupState: false })
    }
    getloanLeads(adminEmail) {
        this.setState({ loaderState: true })
        // this.props.getLoanApprovalLead(this.state.followUpStatus, this.state.forwordPageState, adminEmail, this.state.searchByDate, '', this.state.searchByEndDate, this.state.tabType, '', '203', '', '', '', this.state.selectednbfcFilter,
        //     (callBack) => {
        //         this.setState({ loaderState: false, allUserDetail: callBack })
        //     })
        const params = CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE)
            ? "&loanAmount=" + (this.state.netAmountValue === "HIGH_VALUE" ? ">25000" : "<25000")
            : "";

        fetch(
            APIS.GET_LOAN_APPROVAL_LEAD +
            this.state.followUpStatus +
            '&pageNumber=' +
            this.state.forwordPageState +
            '&empId=' +
            adminEmail +
            '&date=' +
            this.state.searchByDate +
            '&nbfcName=' +
            '&eDate=' +
            this.state.searchByEndDate +
            '&tabType=' +
            this.state.tabType +
            '&loanFrom='
            + '&subStatus='
            + "203"
            + '&teaGardenId='
            + '&teaGardenEmpId='
            + '&dateType=' + "&nbfcId=" + this.state.selectednbfcFilter + params)
            .then(res => res.json())
            .then(json => {
                if (json.responseCode == 0) {
                } else {
                    this.setState({ loaderState: false, allUserDetail: json })
                }
            })
    }
    refresh() {
        const { admin } = this.props
        this.getloanLeads(admin.emailId)
    }
    componentDidMount() {
        this.setState({ netAmountValue: CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ? "Low_VALUE" : "" })
        this.getNbfcListFn()

        dataTosend = []
    }
    changehandler(e, data) {
        if (e.target.checked) {
            dataTosend.push(data.loanId)

        } else {
            let check = dataTosend.includes(data.loanId)
            if (check) {
                const index = dataTosend.indexOf(data.loanId);
                if (index > -1) {
                    dataTosend.splice(index, 1);

                }
            }
        }
    }
    changehandlerRadio(e, data) {
        if (e.target.checked) {
            dataTosend = [data.loanId];

        }
    }
    paginationHandler(type) {
        if (type == 'left') {
            if (this.state.forwordPageState > 1) {
                this.setState({
                    forwordPageState: this.state.forwordPageState - 1,

                }, () => this.getloanLeads())
            }
        } if (type == 'right') {
            this.setState({
                forwordPageState: this.state.forwordPageState + 1,

            }, () => this.getloanLeads())
        }
    }
    paymentAndVerificationHandler(type) {
        const { admin } = this.props
        if (type === 'verify') {
            this.setState({ loaderState: true })
            if (dataTosend.length === 0) {
                this.setState({ popupState: true, popupStatus: 'Please Select Application To verify', loaderState: false }, () => this.removePopup())
            } else {
                if (CHECK_COMPANY_TENANT(ABHICASH_LIKE)) {


                    verifyIciciPaymentsPenalty(admin.emailId, this.state.penaltyMethodOption.penaltyMethod, dataTosend, callBack => {
                        this.setState({ paymentData: JSON.parse(callBack) })
                        this.handlerPenaltyOption(false, "")
                        if (callBack) {
                            this.setState({ popupState: true, popupStatus: 'Check Payment Status Column', loaderState: false, playingState: true }, () => this.removePopup())

                        } else {
                            this.setState({ popupState: true, popupStatus: 'Please try again later', loaderState: false }, () => this.removePopup())
                        }


                    })
                } else {
                    verifyIciciPayments(admin.emailId, dataTosend, callBack => {
                        this.setState({ paymentData: JSON.parse(callBack) })
                        this.handlerPenaltyOption(false, "")
                        if (callBack) {
                            this.setState({ popupState: true, popupStatus: 'Check Payment Status Column', loaderState: false, playingState: true }, () => this.removePopup())

                        } else {
                            this.setState({ popupState: true, popupStatus: 'Please try again later', loaderState: false }, () => this.removePopup())
                        }


                    })


                }


            }
        }
        if (type === 'payment') {
            if (dataTosend.length !== 0) {
                this.setState({ loaderState: true })
                BulkPaymentICICI(dataTosend, callBack => {
                    if (callBack) {
                        let data = JSON.parse(callBack)

                        this.setState({ paymentData: JSON.parse(callBack) })
                        this.setState({ loanIdData: Object.keys(data) + ',' + Object.values(data) })
                        this.setState({ popupState: true, popupStatus: 'Check Payment Status Column', loaderState: false, playingState: true }, () => this.removePopup())

                    } else {
                        this.setState({ popupState: true, popupStatus: 'Please try again later', loaderState: false }, () => this.removePopup())
                    }
                })
            } else {
                this.setState({ popupState: true, popupStatus: 'Please Select Appliaction for payment', loaderState: false }, () => this.removePopup())

            }
        }
    }
    removePopup() {
        setTimeout(function () {
            this.setState({ popupState: false, playingState: false });
        }.bind(this), 5000)
    }
    handleSongFinishedPlaying() {
        this.setState({ playingState: false })
    }

    getNbfcListFn() {
        getNbfcList((callback) => {
            this.setState({ nbfcList: callback })
        })
    }


    handleNBfc(e) {
        const { admin } = this.props;
        this.setState({ selectAll: false })
        dataTosend = []
        newdataToCheck.map((newl, i) =>
            document.getElementById('disburseIcici' + newl).checked = false
        )
        if (e.target.value !== "") {
            this.setState({ selectednbfcFilter: e.target.value, allUserDetail: "" }, () => this.getloanLeads(admin.emailId))
        } else {
            this.setState({ selectednbfcFilter: e.target.value, allUserDetail: '' })
        }
    }

    handlerPenaltyOption(s, value) {
        this.setState({ penaltyMethodOption: { show: s, penaltyMethod: value } })
    }

    handleNetAmount(e) {
        const { admin } = this.props;
        dataTosend = [];
        this.setState({ netAmountValue: e.target.value }, () => this.getloanLeads(admin.emailId))
    }

    OpenOTPPopup(value, callDisburse = false) {
        const { admin } = this.props;
        this.setState({ OTPpopup: value })
        if (value == true) {
           const ar = this.state.allUserDetail.filter((el) => dataTosend?.includes(el?.loanId));

            const totalAmount = ar?.reduce((sum, item) => {
                return sum + (Number(item?.netdisbursmentAmount) || 0);
            }, 0);

            const str =  `phoneNumber=${'9811821102'}&amount=${totalAmount}&empId=${admin?.emailId}&type=${this.state.netAmountValue}&applicationId=`
            const appId = this.state.netAmountValue == "HIGH_VALUE" ? ar?.[0]?.applicationId : "null"
            const newStr = str + appId
            
           
            getDisbursmentOtpSendByData(newStr, callback => {

            })
        }
        if (callDisburse == true) {
            this.setState({ popupState: true, popupStatus: 'Authorised Successfully', loaderState: false }, () => this.removePopup())
            this.paymentAndVerificationHandler('payment')
        }
    }


    render() {
        const {admin} = this.props;
        return (
            <div>
                {
                    CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ?
                        <OTPUi
                            refresh={this.refresh.bind(this)}
                            selectAll={this.selectAll.bind(this)}
                            pageNumber={this.state.forwordPageState}
                            paginationHandler={this.paginationHandler.bind(this)}
                            loanIdData={this.state.loanIdData}
                            ApplicationId={ApplicationId}
                            paymentData={this.state.paymentData}
                            allUserDetail={this.state.allUserDetail}
                            changehandler={this.changehandler.bind(this)}
                            changehandlerRadio={this.changehandlerRadio.bind(this)}
                            paymentAndVerificationHandler={this.paymentAndVerificationHandler.bind(this)}
                            selectednbfcFilter={this.state.selectednbfcFilter}
                            nbfcList={this.state.nbfcList}
                            handleNBfc={this.handleNBfc.bind(this)}
                            selectAllBtn={this.state.selectAll}
                            handlerPenaltyOption={this.handlerPenaltyOption.bind(this)}
                            penaltyMethodOption={this.state.penaltyMethodOption}
                            tenant={this.props.tenant} netAmountValue={this.state.netAmountValue}
                            handleNetAmount={this.handleNetAmount.bind(this)}
                            OpenOTPPopup={this.OpenOTPPopup.bind(this)}
                            OTPpopup={this.state.OTPpopup} admin={admin}
                        />
                        :
                        <Ui
                            refresh={this.refresh.bind(this)}
                            selectAll={this.selectAll.bind(this)}
                            pageNumber={this.state.forwordPageState}
                            paginationHandler={this.paginationHandler.bind(this)}
                            loanIdData={this.state.loanIdData}
                            ApplicationId={ApplicationId}
                            paymentData={this.state.paymentData}
                            allUserDetail={this.state.allUserDetail}
                            changehandler={this.changehandler.bind(this)}
                            paymentAndVerificationHandler={this.paymentAndVerificationHandler.bind(this)}
                            selectednbfcFilter={this.state.selectednbfcFilter}
                            nbfcList={this.state.nbfcList}
                            handleNBfc={this.handleNBfc.bind(this)}
                            selectAllBtn={this.state.selectAll}
                            handlerPenaltyOption={this.handlerPenaltyOption.bind(this)}
                            penaltyMethodOption={this.state.penaltyMethodOption}
                            tenant={this.props.tenant}
                        />
                }

                {this.state.loaderState ?
                    <Loader />
                    : ""}
                {this.state.popupState == true ? (
                    <Popup
                        closePopup={this.closePopup.bind(this)}
                        popupStatus={this.state.popupStatus}
                    />
                ) : (
                    ''
                )}
                {this.state.playingState == true ?
                    <audio autoPlay>
                        <source src={RingTone} type="audio/mpeg" />
                    </audio>
                    : ""}

            </div>
        )
    }
}
const mapStateToProps = ({ allUserDetail, loanApprovalLead, tenant }) => {
    return {
        allUserDetail: allUserDetail,
        loanApprovalLead: loanApprovalLead,
        tenant: tenant.activeTenant
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getLoanApprovalLead
    }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(Bank);